// Dumb card — no store, no SQL. TotalSparkCard with a filter switch beside the label, upstreamed
// from issue-analysis's components/cards/TotalSparkCardWithSwitch.vue (IA_ABSORPTION_PLAN Phase 4
// step 13) with the same x-axis label fix as TotalSparkCard. Unlike TotalCardWithSwitch, the switch
// shows only while `count > 0` (it hides again at 0), toggles report through the native `change`
// event, and the count animates like TotalCard's (first change snaps — variant A); all three as
// they were in issue-analysis.
//
//   emits: update:selected (Boolean), filterChange ({ id: identifier, selected })
import setup from './setup.js';

export default {
  name: 'total-spark-card-with-switch',
  props: {
    label: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    tooltip: {
      type: String,
      required: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    identifier: {
      type: String,
      required: true
    },
    // Sparkline properties
    showSparkline: {
      type: Boolean,
      default: false
    },
    sparklineData: {
      type: Array,
      default: () => []
    },
    sparklineColor: {
      type: String,
      default: 'primary'
    },
    sparklineGradient: {
      type: Array,
      default: null
    },
    sparklineHeight: {
      type: Number,
      default: 50
    },
    sparklineLineWidth: {
      type: Number,
      default: 2
    },
    sparklineMin: {
      type: Number,
      default: 0
    },
    sparklineSmooth: {
      type: Boolean,
      default: true
    },
    sparklineLabels: {
      type: Array,
      default: () => []
    },
    // Percentage change properties
    showPercentageChange: {
      type: Boolean,
      default: false
    },
    percentageChange: {
      type: Number,
      default: null
    }
  },
  emits: ['update:selected', 'filterChange'],
  setup,
};
